<mat-form-field appearance="outline"
                class="form-field-input">
  <mat-label>{{ title! | translate }}</mat-label>
  <input
    #inputControl="ngModel"
    (blur)="onTouched()"
    (change)="onChange()"
    (keypress)="onKeyPress($event)"
    (keyup)="onChange()"
    [(ngModel)]="internalValue"
    [attr.pattern]="type === 'number' ? '[0-9۰-۹٠-٩.,\\s]*' : null"
    [disabled]="disabled"
    [englishNumberOnly]="type === 'number' ? englishNumberOnly : false"
    [placeholder]="placeHolder"
    [required]="required"
    [title]="value"
    [type]="type === 'password' ? (hide ? 'password' : 'text') : (type === 'number' ? 'text' : type!)"
    matInput
  />

  @if (inputControl.errors?.['required']) {
    <mat-error>{{ 'این فیلد اجباری است' }}</mat-error>
  }
  @if (type === 'password') {
    <button (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
            class="mat-icon-eyes-button"
            mat-icon-button
            matSuffix>
      @if (!hide) {
        <img src="/icons/eye.svg"/>
      } @else {
        <img src="/icons/eye-slash.svg"/>
      }
    </button>
  }
  @if (lookup) {
    <button
      (click)="onLookupClicked()"
      class="mat-icon-eyes-button"
      mat-icon-button
      matSuffix
    >
      <mat-icon color="icon-blue">search</mat-icon>
    </button>
  }
</mat-form-field>
